import { factory } from '../../../../factory-api/factory'
import { defineStore } from 'pinia'
import type { AuthProgram } from '@/generated-api'
import { useAppStore } from './app'

export const useProgrammeStore = defineStore('programme', () => {
  const appStore = useAppStore()

  const activeProgrammeId = ref<string>('')
  const programmes: Ref<AuthProgram[]> = ref<AuthProgram[]>([])
  const selectedProgramme: Ref<AuthProgram | undefined> = ref(undefined)
  const isSelectingProgramme = ref<boolean>(false)

  async function selectProgramme(programme: AuthProgram) {
    try {
      if (programme !== undefined && programme.programmeId !== undefined) {
        const memberApi = await factory.getMemberApi()
        const response = await memberApi.selectProgramme({ programmeId: programme.programmeId })
        console.log('selectProgramme ', response)

        if (response === true) {
          await appStore.getSiteContent()
          selectedProgramme.value = programme
          return response
        } else {
          return response
        }
      }
      return false
    } catch (error) {
      console.error(error)
      return false
    }
  }

  function setSelectedProgramme(programme: AuthProgram | undefined) {
    selectedProgramme.value = programme
  }

  function setProgrammes(programmeList: AuthProgram[]) {
    programmes.value = programmeList
  }

  function setActiveProgrammeId(programmeId: string) {
    activeProgrammeId.value = programmeId
  }

  const setIsSelectingProgramme = (bool: boolean) => {
    isSelectingProgramme.value = bool
  }

  const hasAcceptedTerms: () => boolean = () => {
    return !!programmes.value.find((prg: AuthProgram) => prg.consentDate !== undefined)
  }

  const toSelectProgramme: () => boolean = () => {
    return (
      (programmes.value.length > 1 && selectedProgramme.value === undefined) ||
      hasAcceptedTerms() === false
    )
  }

  const resetSelectedProgramme = async () => {
    try {
      const memberApi = await factory.getMemberApi()
      await memberApi.selectProgramme({ programmeId: '0' })
      window.location.replace('/')
    } catch (error) {
      console.error(error)
    }
  }

  function resetProgrammeStore() {
    setActiveProgrammeId('')
    setSelectedProgramme(undefined)
    setProgrammes([])
  }

  return {
    selectedProgramme,
    setSelectedProgramme,
    programmes,
    setProgrammes,
    setActiveProgrammeId,
    activeProgrammeId,
    selectProgramme,
    hasAcceptedTerms,
    toSelectProgramme,
    resetProgrammeStore,
    isSelectingProgramme,
    setIsSelectingProgramme,
    resetSelectedProgramme
  }
})
